import React, { forwardRef, useState } from 'react';
import { isValidDateTimeString, printDateTime } from '@guryou/utils';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
const toPlainValue = val => {
  if (val && typeof val === 'object') {
    if (Array.isArray(val)) {
      const distinctById = val.filter((obj1, i, arr) => {
        if (obj1.hasOwnProperty('id')) {
          return arr.findIndex(obj2 => obj2.id === obj1.id) === i;
        }
        return true;
      });
      return distinctById.map(toPlainValue).join(', ');
    }
    const {
      title,
      name,
      firstname,
      lastname,
      email,
      label,
      value,
      description
    } = val;
    const nameOrEmail = firstname ? "".concat(firstname, " ").concat(lastname || '') : email;
    return title || name || label || value || description || nameOrEmail;
  }
  if (isValidDateTimeString(val)) {
    return printDateTime(val);
  }
  return val !== null && val !== void 0 ? val : '';
};
const onDownloadHandler = (buildHead, buildBody, columns, data) => {
  const ignoredLabels = [' ', 'Actions', 'Azioni', 'Contatto', 'Contact'];
  const indexes = columns.map((c, i) => {
    if (c.display === 'false' && c.label !== 'To' && c.label !== 'A' || ignoredLabels.includes(c.label)) {
      return i;
    } else {
      return -1;
    }
  }).filter(x => x !== -1);
  const plainData = data.map(d => ({
    index: d.index,
    data: d.data.filter((_, i) => indexes.indexOf(i) === -1).map(toPlainValue)
  }));
  const newCols = columns.filter((_, i) => indexes.indexOf(i) === -1);
  return buildHead(newCols) + buildBody(plainData);
};
const Table = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    columns,
    data,
    title,
    toolbars = null,
    renderExpandableRow = null,
    showDownloadTool,
    showPrintTool,
    customKey,
    customClass,
    singleExpandedRow,
    setDisableSort,
    rowsPerPageOptions = [10],
    downloadFilename = 'Waas.csv'
  } = _ref;
  const [localState, setLocalState] = useState({
    rowsExpanded: [],
    currentPage: 0
  });
  const options = {
    onColumnSortChange: () => setDisableSort && setDisableSort(true),
    fixedHeader: false,
    viewColumns: false,
    print: showPrintTool,
    download: showDownloadTool,
    filter: false,
    search: false,
    page: localState.currentPage,
    rowsPerPageOptions,
    enableNestedDataAccess: '.',
    selectableRows: 'none',
    filterType: 'dropdown',
    customToolbar: () => toolbars,
    customBodyRender: value => {
      return value;
    },
    setRowProps: (_, rowIndex) => {
      if (localState.rowsExpanded.includes(rowIndex)) {
        return {
          className: 'active'
        };
      }
    },
    downloadOptions: {
      filename: downloadFilename
    }
  };
  if (renderExpandableRow) {
    singleExpandedRow && (options.rowsExpanded = localState.rowsExpanded);
    options.expandableRows = true;
    options.renderExpandableRow = renderExpandableRow;
    options.expandableRowsOnClick = false;
    options.onRowExpansionChange = currentRows => {
      const [row] = currentRows;
      const page = ~~(row.dataIndex / 10);
      if (localState.rowsExpanded[0] !== row.dataIndex || page !== localState.currentPage) {
        setLocalState({
          rowsExpanded: [row.dataIndex],
          currentPage: page
        });
      }
    };
  }
  if (showDownloadTool) {
    options.onDownload = onDownloadHandler;
  }
  return /*#__PURE__*/React.createElement(MUIDataTable, {
    ref: ref,
    className: customClass,
    key: "".concat(customKey).concat(localState.rowsExpanded[0], "_").concat(localState.currentPage),
    title: title,
    data: data,
    columns: columns,
    options: options
  });
});
Table.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  toolbars: PropTypes.any,
  singleExpandedRow: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.object
  }))
};
export default Table;